import { Button, TagsInput, Typography } from '@mantine/core';
import { ErrorBoundary } from '@sentry/react';
import { Panel } from 'components/Panel';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { tKeys, useTranslation } from 'locales';
import { useState } from 'react';
import HTML from 'shared/components/HTML/HTML';

import { useUpdateExcludedAccounts } from '../hooks';

const ExcludedAccountsInner = () => {
  const { t } = useTranslation();
  const { tp_accounting } = useCompanyConfiguration();
  const { updateExcludedAccounts, isUpdateExcludedAccountsLoading } = useUpdateExcludedAccounts();

  const [accountNumbers, setAccountNumbers] = useState<Array<string>>(
    tp_accounting.excluded_account_numbers,
  );
  const isDirty =
    JSON.stringify(accountNumbers) !== JSON.stringify(tp_accounting.excluded_account_numbers);

  return (
    <Panel
      title={t(tKeys.SETTINGS.INTEGRATIONS.EXCLUDED_ACCOUNTS.TITLE)}
      footer={
        <Button
          disabled={!isDirty}
          onClick={() => updateExcludedAccounts(accountNumbers)}
          loading={isUpdateExcludedAccountsLoading}
        >
          {t(tKeys.SAVE)}
        </Button>
      }
    >
      <Typography fz="sm" color="dimmed" mb="md">
        <HTML html={t(tKeys.SETTINGS.INTEGRATIONS.EXCLUDED_ACCOUNTS.DESCRIPTION)} />
      </Typography>
      <TagsInput
        w={400}
        label={t(tKeys.SETTINGS.INTEGRATIONS.EXCLUDED_ACCOUNTS.LABEL)}
        acceptValueOnBlur
        value={accountNumbers}
        onChange={setAccountNumbers}
      />
    </Panel>
  );
};

export const ExcludedAccounts = () => (
  <ErrorBoundary fallback={<div>Error loading excluded accounts settings.</div>}>
    <ExcludedAccountsInner />
  </ErrorBoundary>
);
